// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.savedreply.SatelliteWebLandlordSavedReplyHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebLandlordSavedReplyHandler_addSavedReplies,
  SatelliteWebLandlordSavedReplyHandler_deleteSavedReplies,
  SatelliteWebLandlordSavedReplyHandler_editSavedReply,
  SatelliteWebLandlordSavedReplyHandler_getSavedReplies,
  SatelliteWebLandlordSavedReplyHandler_getSavedReplies_Path,
} from '@zg-rentals/ts-satellite-client';

import type {
  SatelliteWebLandlordSavedReplyAddSavedRepliesRequestDto,
  SatelliteWebLandlordSavedReplyDeleteSavedRepliesRequestDto,
  SatelliteWebLandlordSavedReplyEditSavedReplyRequestDto,
  SatelliteWebLandlordSavedReplyGetSavedRepliesResponseDto,
} from '@zg-rentals/ts-satellite-client';

export interface SatelliteWebLandlordSavedReplyHandler_addSavedReplies_Args {
  postData: SatelliteWebLandlordSavedReplyAddSavedRepliesRequestDto;
}

export type SatelliteWebLandlordSavedReplyHandler_addSavedReplies_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordSavedReplyHandler_addSavedReplies_Args
>;

/**
 * Add saved replies
 */
export const useSatelliteWebLandlordSavedReplyHandler_addSavedReplies = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordSavedReplyHandler_addSavedReplies_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordSavedReplyHandler_addSavedReplies_Args) =>
      SatelliteWebLandlordSavedReplyHandler_addSavedReplies(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordSavedReplyHandler_deleteSavedReplies_Args {
  postData: SatelliteWebLandlordSavedReplyDeleteSavedRepliesRequestDto;
}

export type SatelliteWebLandlordSavedReplyHandler_deleteSavedReplies_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordSavedReplyHandler_deleteSavedReplies_Args
>;

/**
 * Delete saved replies
 */
export const useSatelliteWebLandlordSavedReplyHandler_deleteSavedReplies = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordSavedReplyHandler_deleteSavedReplies_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordSavedReplyHandler_deleteSavedReplies_Args) =>
      SatelliteWebLandlordSavedReplyHandler_deleteSavedReplies(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordSavedReplyHandler_editSavedReply_Args {
  postData: SatelliteWebLandlordSavedReplyEditSavedReplyRequestDto;
}

export type SatelliteWebLandlordSavedReplyHandler_editSavedReply_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordSavedReplyHandler_editSavedReply_Args
>;

/**
 * Edit a saved reply
 */
export const useSatelliteWebLandlordSavedReplyHandler_editSavedReply = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordSavedReplyHandler_editSavedReply_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordSavedReplyHandler_editSavedReply_Args) =>
      SatelliteWebLandlordSavedReplyHandler_editSavedReply(args.postData, httpClient),
  });
};

export type SatelliteWebLandlordSavedReplyHandler_getSavedReplies_Options = UseQueryOptions<
  SatelliteWebLandlordSavedReplyGetSavedRepliesResponseDto,
  unknown,
  SatelliteWebLandlordSavedReplyGetSavedRepliesResponseDto,
  readonly [string]
>;

const SatelliteWebLandlordSavedReplyHandler_getSavedReplies_GetKey = () =>
  [SatelliteWebLandlordSavedReplyHandler_getSavedReplies_Path] as const;

export const SatelliteWebLandlordSavedReplyHandler_getSavedReplies_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebLandlordSavedReplyHandler_getSavedReplies_GetKey(),
    queryFn: () => SatelliteWebLandlordSavedReplyHandler_getSavedReplies(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get saved replies
 */
export const useSatelliteWebLandlordSavedReplyHandler_getSavedReplies = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordSavedReplyHandler_getSavedReplies_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...SatelliteWebLandlordSavedReplyHandler_getSavedReplies_queryOptions({ httpClient }),
    ...options,
  });
};
useSatelliteWebLandlordSavedReplyHandler_getSavedReplies.getKey =
  SatelliteWebLandlordSavedReplyHandler_getSavedReplies_GetKey;
